import styled from 'styled-components';

const PermissionsShowStyles = styled.div`
`;

export default PermissionsShowStyles;
